import { predictionsRoute } from "./apiroutes";
import customAxios from "./interceptor";

export const getPredictions = ({
  page,
  limit,
  searchQuery,
  status,
  sortBy,
  sortOrder,
}) => {
  return async () => {
    try {
      const params = { page, limit };
      if (searchQuery) params.search = searchQuery;
      if (status && status !== "all") params.status = status;
      if (sortBy) params.sortBy = sortBy;
      if (sortOrder) params.sortOrder = sortOrder;

      const response = await customAxios.get(predictionsRoute, { params });
      return { status: true, data: response.data };
    } catch (err) {
      return { status: false, message: err.message };
    }
  };
};

export const getPredictionById = (id) => {
  return async () => {
    try {
      const response = await customAxios.get(`${predictionsRoute}/${id}`);
      return { status: true, data: response.data };
    } catch (err) {
      return { status: false, message: err.message };
    }
  };
};

export const createPrediction = (data) => {
  return async () => {
    try {
      const response = await customAxios.post(predictionsRoute, data);
      return { status: true, data: response.data };
    } catch (err) {
      return { status: false, message: err.message };
    }
  };
};

export const updatePrediction = (id, data) => {
  return async () => {
    try {
      const response = await customAxios.put(
        `${predictionsRoute}/${id}`,
        data
      );
      return { status: true, data: response.data };
    } catch (err) {
      return { status: false, message: err.message };
    }
  };
};

export const publishPrediction = (id) => {
  return async () => {
    try {
      const response = await customAxios.patch(
        `${predictionsRoute}/${id}/publish`
      );
      return { status: true, data: response.data };
    } catch (err) {
      return { status: false, message: err.message };
    }
  };
};

export const deletePrediction = (id) => {
  return async () => {
    try {
      const response = await customAxios.delete(`${predictionsRoute}/${id}`);
      return { status: true, data: response.data };
    } catch (err) {
      return { status: false, message: err.message };
    }
  };
};
